<section>
  <h2>Summary and Notes</h2>
  <form [formGroup]="summaryNotesForm" (ngSubmit)="onSubmit()" class="w-lg-75">
    <div class="mb-3">
      <label for="Summary" class="form-label">Summary (maximum 4000 characters)</label>
      <textarea [rows]="textAreaRows" id="Summary" class="form-control" formControlName="Summary" maxlength="4000"></textarea>
      <div class="invalid-feedback">
        The summary must be 4000 characters or less.
      </div>
    </div>
    <div class="mb-3">
      <label for="Notes" class="form-label">Notes</label>
      <textarea [rows]="textAreaRows" id="Notes" formControlName="Notes" class="form-control"></textarea>
    </div>
    <h3 class="mb-3">Attachments</h3>
    <div class="font-size-xs text-italic mb-3">
      Notes:
      <ol>
        <li><i>Total # of upload files allowed: {{ totalNumberOfUploadFilesAllowed }}</i></li>
        <li><i>Max size allowed per file: 5MB</i></li>
        <li><i>File types supported: PDF, JPG, PNG, TIFF, JPEG, ANB, DOC, DOCX, XLS, XLSX, PPT, PPTX, MSG</i></li>
      </ol>
    </div>
    <p-fileUpload #fileInput url="{{apiRoot}}/api/IntelligenceReport/IntelligenceReportAttachmentUpload"
                  [multiple]="true"
                  name="attachments[]"
                  [showUploadButton]="false" accept=".pdf,.PDF,.jpg,.JPG,.png,.PNG,.tiff,.TIFF,.jpeg,.JPEG,.anb,.ANB,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.ppt,.PPT,.pptx,.PPTX,.msg,.MSG"
                  [maxFileSize]="maxFileSize"
                  invalidFileSizeMessageSummary="{0}: Invalid file size."
                  invalidFileSizeMessageDetail="Maximum upload size is {0}. File was NOT uploaded."
                  (onSelect)="validateMaxFiles($event)"
                  (onClear)="OnCancel()"
                  (onRemove)="validateMaxFiles($event)"
                  (onUpload)="onFileUpload($event)"
                  (onError)="onUploadErrorHandler($event)"
                  styleClass="mb-3">
    </p-fileUpload>
    <div class="cross-validation-feedback" *ngIf="displayAttachmentErrorMessage"> {{ attachmentUploadErrorMessage}} </div>
    <a aria-hidden="true" class="d-none" #downloadTemplateLink></a>
    <p-table [value]="uploadedFiles" [paginator]="true" [alwaysShowPaginator]="false" responsiveLayout="scroll" styleClass="mb-3" [rows]="rows" [autoLayout]="true" *ngIf="uploadedFiles.length > 0">
      <ng-template pTemplate="caption">
        <div class="p-2 fw-medium text-center">
          Uploaded attachments
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">File name</th>
          <th scope="col" class="text-nowrap">Created by</th>
          <th scope="col" class="text-nowrap">Created on</th>
          <th scope="col" class="w-10"><span class="visually-hidden">Remove</span></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2">
            No uploaded attachments found.
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <th scope="row"><a tabindex="0" class="download-link" title="Download attachment file" (click)="onClickDownload(rowData)">{{rowData.FileName}}</a></th>
          <td>{{rowData.CreatedBy}}</td>
          <td>{{rowData.CreatedOn | date:'MM/dd/yyyy'}}</td>
          <td class="text-center w-10">
            <button type="button" class="btn btn-sm btn-danger" aria-label="Remove attachment" (click)="deleteUploadedAttachment(rowData)"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove attachment</span></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <table class="temp-bs table table-sm table-striped table-bordered mb-3">
      <caption class="caption-top form-label text-body">Date(s) information report sent</caption>
      <thead>
        <tr>
          <th scope="col">Date sent</th>
          <th scope="col">Recipient(s)</th>
          <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="ENESS_XREF_IRsDatesSent.controls.length==0;else datesentrows"><tr><td colspan="3">No sent dates found.</td></tr></ng-container>
        <ng-template #datesentrows>
          <tr *ngFor="let ds of ENESS_XREF_IRsDatesSent.controls;let i = index">
            <th scope="row">{{ds.get('DateSent').value | date:'MM/dd/yyyy' }}</th>
            <td>{{ds.get('Recipients').value}}</td>
            <td class="w-10 text-center">
              <button type="button" aria-label="Delete date sent" title="Delete date sent" class="btn btn-sm btn-danger" (click)="ENESS_XREF_IRsDatesSent.removeAt(i)"><i class="fas fa-times" aria-hidden="true"></i></button>
            </td>
          </tr>
        </ng-template>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3" class="p-3">
            <div class="row row-cols-lg-auto gy-2 gx-3 align-items-start" [formGroup]="sentDatesForm">
                <div class="col-12">
                  <label class="form-label" for="DateSent">
                    Date information report sent:
                  </label>
                  <p-calendar formControlName="DateSent" inputId="DateSent" [showIcon]="true" styleClass="d-flex" inputStyleClass="form-control" [showOnFocus]="false" (onSelect)="sentDatesForm.get('Recipients').enable()" (onBlur)="onDateSentBlur()"></p-calendar>
                </div>
                <div class="col-12 flex-grow-1">
                  <label for="Recipients" class="form-label" [class.required-field]="!sentDatesForm.get('Recipients').disabled">Recipient(s):</label>
                  <input #recips formControlName="Recipients" id="Recipients" type="text" class="form-control" required aria-required="true" />
                  <div class="invalid-feedback">
                    At least one recipient is required.
                  </div>
                </div>
              </div>
              <button type="button" [disabled]="!this.sentDatesForm.get('DateSent').value || !this.sentDatesForm.valid" (click)="addIRSentDate()" class="btn btn-sm btn-success mt-3"><i class="fa fa-plus" aria-hidden="true"></i> Add sent date</button>
          </td>
        </tr>
      </tfoot>
    </table>
  </form>
</section>
